<div class="d-flex align-items-center flex-nowrap justify-content-between">
<span
  [ngClass]="{'text-underline' : !params.isSourcing}"
  class="hand text-nowrap"
  (click)="changeRoute(params)"
  [ngbTooltip]="params?.value ? params?.value : null"
  placement="right"
  container="body"
  >{{params?.value || "&#8212;" }}</span
>
<ng-container *ngIf="params?.data?.isNewOffer">
  <span class="badge hold-btn px-2 text-nowrap ms-2 rounded-3 special-font">New Offers</span>
</ng-container>
</div>
